function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "icon_card",
  transform: "translate(-853.355 -976.304)"
}, React.createElement("path", {
  id: "Path_49",
  "data-name": "Path 49",
  d: "M912.5,978.349H859.662a4.281,4.281,0,0,0-4.261,4.261v31.7a4.24,4.24,0,0,0,1.248,3.006l0,0,0,0a4.249,4.249,0,0,0,3.008,1.255H912.5a4.277,4.277,0,0,0,4.261-4.261v-31.7a4.277,4.277,0,0,0-4.261-4.261ZM859.662,976.3H912.5a6.321,6.321,0,0,1,6.307,6.306v31.7a6.321,6.321,0,0,1-6.307,6.307H859.662a6.29,6.29,0,0,1-4.455-1.854l0,0a6.289,6.289,0,0,1-1.854-4.451v-31.7a6.321,6.321,0,0,1,6.307-6.306Z",
  transform: "translate(0)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_50",
  "data-name": "Path 50",
  d: "M861.818,986.844h34.345a1.023,1.023,0,0,1,1.023,1.022v5.284a1.024,1.024,0,0,1-1.023,1.023H861.818a1.026,1.026,0,0,1-1.023-1.023v-5.284a1.024,1.024,0,0,1,1.023-1.022Zm33.322,2.045h-32.3v3.236h32.3Z",
  transform: "translate(8.412 11.916)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_51",
  "data-name": "Path 51",
  d: "M858.1,995.711a1.024,1.024,0,0,1,0-2.047h50.2a1.024,1.024,0,0,1,0,2.047Z",
  transform: "translate(4.206 19.626)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_52",
  "data-name": "Path 52",
  d: "M854.378,978.784h63.406a1.023,1.023,0,0,1,1.023,1.023v10.568a1.023,1.023,0,0,1-1.023,1.023H854.378a1.023,1.023,0,0,1-1.023-1.023V979.807a1.023,1.023,0,0,1,1.023-1.023Zm62.384,2.046H855.4v8.522h61.361Z",
  transform: "translate(0 2.804)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_53",
  "data-name": "Path 53",
  d: "M908.806,979.3a1.018,1.018,0,1,1,1.766,1.014l-.763,1.321,0,0,0,0-.763,1.319-.03.047-.733,1.272-.763,1.321v0h0l-.763,1.323a1.02,1.02,0,0,1-1.766-1.023l.763-1.321h0l.76-1.317.733-1.27.03-.055.763-1.321,0,0,.76-1.319Zm-48.316,0a1.021,1.021,0,1,1,1.766,1.023l-.763,1.321-.03.045-.733,1.272v0h0l-.763,1.323-.03.045-.733,1.272v0h0l-.763,1.323a1.02,1.02,0,0,1-1.766-1.023l.763-1.321h0l.731-1.266.03-.055.763-1.321h0l.731-1.266.03-.055.763-1.321Zm8.052,0a1.018,1.018,0,1,1,1.766,1.014l-.761,1.321,0,0,0,0-.765,1.319-.028.047-.733,1.272-.763,1.321,0,0h0l-.763,1.323a1.021,1.021,0,0,1-1.766-1.023l.763-1.321h0l.76-1.317.731-1.27.03-.055.765-1.321v0l.761-1.319Zm8.054,0a1.021,1.021,0,1,1,1.766,1.023l-.763,1.321-.03.045-.733,1.272,0,0h0l-.763,1.323-.03.045-.733,1.272-.763,1.321a1.018,1.018,0,0,1-1.766-1.014l.763-1.323.733-1.268.03-.055.763-1.321h0l.731-1.266.03-.055.763-1.321Zm8.052,0a1.018,1.018,0,1,1,1.766,1.014l-.763,1.321-.761,1.321,0,0h0l-.765,1.323-.028.045-.733,1.272,0,0h0l-.765,1.323a1.02,1.02,0,0,1-1.764-1.023l.763-1.321h0l.731-1.266.032-.055.763-1.321h0l.763-1.317.761-1.321Zm8.054,0a1.018,1.018,0,1,1,1.766,1.014l-.763,1.321v0l-.763,1.319-.03.047-.733,1.272v0l-.763,1.319-.03.047-.733,1.272a1.018,1.018,0,0,1-1.766-1.014l.733-1.27.03-.055.763-1.321,0,0,.731-1.268.03-.055.763-1.321,0,0,.76-1.319Zm8.054,0a1.02,1.02,0,1,1,1.766,1.023l-.765,1.321-.028.045L901,982.955l0,0h0l-.765,1.323-.028.045-.733,1.272-.763,1.321a1.018,1.018,0,0,1-1.766-1.014l.763-1.323.731-1.268.03-.055.765-1.321h0l.731-1.266.03-.055Z",
  transform: "translate(3.601 2.805)",
  fill: "#4bc9c9",
  fillRule: "evenodd"
}));

var SvgIconCard = function SvgIconCard(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 65.452,
    height: 44.316,
    viewBox: "0 0 65.452 44.316",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_card.f20b133e.svg";
export { ForwardRef as ReactComponent };